import z from 'zod';
import { AlarmSeverity, AlarmType, assetGroupRef, assetRef, contactListRef, zoneRef, scopedEntity, schedule, locale, string, procedureString, } from '../common';
export var ObservationTriggerStatus;
(function (ObservationTriggerStatus) {
    ObservationTriggerStatus["Active"] = "active";
    ObservationTriggerStatus["Inactive"] = "inactive";
})(ObservationTriggerStatus || (ObservationTriggerStatus = {}));
export var ObservationTriggerActionType;
(function (ObservationTriggerActionType) {
    ObservationTriggerActionType["Alarm"] = "alarm";
    ObservationTriggerActionType["Sms"] = "sms";
    ObservationTriggerActionType["Email"] = "email";
})(ObservationTriggerActionType || (ObservationTriggerActionType = {}));
export var ObservationTriggerFilterType;
(function (ObservationTriggerFilterType) {
    ObservationTriggerFilterType["AndOperator"] = "operator/and";
    ObservationTriggerFilterType["OrOperator"] = "operator/or";
    ObservationTriggerFilterType["NotOperator"] = "operator/not";
    ObservationTriggerFilterType["AssetConstraint"] = "constraint/asset";
    ObservationTriggerFilterType["AssetGroupConstraint"] = "constraint/assetGroup";
    ObservationTriggerFilterType["ZoneConstraint"] = "constraint/zone";
    ObservationTriggerFilterType["ScheduleConstraint"] = "constraint/schedule";
})(ObservationTriggerFilterType || (ObservationTriggerFilterType = {}));
export const observationTriggerActionToCollection = z.object({
    toRaw: string.array(),
    toContactList: contactListRef.array(),
    toTriggerUser: z.boolean(),
});
export const observationTriggerActionAlarmConfig = z.object({
    severity: z.nativeEnum(AlarmSeverity),
    type: z.nativeEnum(AlarmType),
    procedure: procedureString,
    name: string,
});
export const observationTriggerActionAlarm = z.object({
    type: z.literal(ObservationTriggerActionType.Alarm),
    config: observationTriggerActionAlarmConfig,
});
export const observationTriggerActionSmsConfig = z.object({
    ...observationTriggerActionToCollection.shape,
    message: string,
});
export const observationTriggerActionSms = z.object({
    type: z.literal(ObservationTriggerActionType.Sms),
    config: observationTriggerActionSmsConfig,
});
export const observationTriggerActionEmailConfig = z.object({
    ...observationTriggerActionToCollection.shape,
    message: string,
    subject: string,
    locale: locale.optional(),
});
export const observationTriggerActionEmail = z.object({
    type: z.literal(ObservationTriggerActionType.Email),
    config: observationTriggerActionEmailConfig,
});
export const anyObservationTriggerAction = z.discriminatedUnion('type', [
    observationTriggerActionAlarm,
    observationTriggerActionSms,
    observationTriggerActionEmail,
]);
/* eslint-disable @typescript-eslint/no-use-before-define */
export const observationTriggerFilterAndOperator = z.lazy(() => z.object({
    type: z.literal(ObservationTriggerFilterType.AndOperator),
    operands: z.array(anyObservationTriggerFilter),
}));
export const observationTriggerFilterOrOperator = z.lazy(() => z.object({
    type: z.literal(ObservationTriggerFilterType.OrOperator),
    operands: z.array(anyObservationTriggerFilter),
}));
export const observationTriggerFilterNotOperator = z.lazy(() => z.object({
    type: z.literal(ObservationTriggerFilterType.NotOperator),
    operand: anyObservationTriggerFilter,
}));
/* eslint-enable @typescript-eslint/no-use-before-define */
export const observationTriggerFilterAssetConstraint = z.object({
    type: z.literal(ObservationTriggerFilterType.AssetConstraint),
    assets: assetRef.array(),
});
export const observationTriggerFilterAssetGroupConstraint = z.object({
    type: z.literal(ObservationTriggerFilterType.AssetGroupConstraint),
    groups: assetGroupRef.array(),
});
export const observationTriggerFilterZoneConstraint = z.object({
    type: z.literal(ObservationTriggerFilterType.ZoneConstraint),
    zone: zoneRef,
});
export const observationTriggerFilterScheduleConstraint = z.object({
    type: z.literal(ObservationTriggerFilterType.ScheduleConstraint),
    schedule,
});
export const anyObservationTriggerFilter = z.union([
    observationTriggerFilterAndOperator,
    observationTriggerFilterOrOperator,
    observationTriggerFilterNotOperator,
    observationTriggerFilterAssetConstraint,
    observationTriggerFilterAssetGroupConstraint,
    observationTriggerFilterZoneConstraint,
    observationTriggerFilterScheduleConstraint,
]);
export const observationTrigger = z.object({
    ...scopedEntity.shape,
    name: string,
    eventCodes: string.array(),
    description: string,
    status: z.nativeEnum(ObservationTriggerStatus),
    actions: anyObservationTriggerAction.array(),
    filter: anyObservationTriggerFilter,
});
